import React from 'react'
import { GridRow } from 'src/components/Reusable/Grid'
import { DocumentRequest } from '@trustero/trustero-api-web/lib/request/request_pb'
import { NoFilterResults } from 'src/components/PageLayout/NoFilterResults'
import { useBannerContext } from 'src/context/Banner/BannerContext'
import {
  bannerHeight,
  filterBarHeight,
  headerContentHeight,
} from 'src/components/PageLayout/dimensionUtils'
import { RequestGridHeader } from '../requests.styles'

export const RequestsIndexGridHeader = ({
  requests,
  stickyHeader = false,
}: {
  requests: DocumentRequest[]
  stickyHeader?: boolean
}): JSX.Element => {
  const { bannerCount } = useBannerContext()
  const top = headerContentHeight + filterBarHeight + bannerCount * bannerHeight
  if (requests.length === 0) {
    return <NoFilterResults />
  }

  return (
    <GridRow>
      <RequestGridHeader $top={top} $sticky={stickyHeader}>
        ID
      </RequestGridHeader>
      <RequestGridHeader $top={top} $sticky={stickyHeader}>
        Name
      </RequestGridHeader>
      <RequestGridHeader $top={top} $sticky={stickyHeader}>
        Type
      </RequestGridHeader>
      <RequestGridHeader $top={top} $sticky={stickyHeader}>
        Description
      </RequestGridHeader>
      <RequestGridHeader $top={top} $sticky={stickyHeader}>
        Audit
      </RequestGridHeader>
      <RequestGridHeader $top={top} $sticky={stickyHeader}>
        Assignee
      </RequestGridHeader>
      <RequestGridHeader $top={top} $sticky={stickyHeader}>
        Due Date
      </RequestGridHeader>
      <RequestGridHeader $top={top} $sticky={stickyHeader}>
        Status
      </RequestGridHeader>
      <RequestGridHeader $top={top} $sticky={stickyHeader}>
        Linked Ticket
      </RequestGridHeader>
      <RequestGridHeader $top={top} $sticky={stickyHeader} />
    </GridRow>
  )
}
